import { ICredentialFeeDefinitionWithIdModel } from 'src/app/shared/models/credential/scenarioRequirementDefinition.model';
import { LedgerCodeModel } from './ledger-codes/ledger-code.model';

export interface IOutOfStateFeeDefinitionModel extends IBaseFeeDefinitionModel {
  inState: string;
}
interface IBaseFeeDefinitionModel {
  amount: number;
  ledgerCode: LedgerCodeModel;
}
export class FeeDefinitionModel implements IBaseFeeDefinitionModel {
  id: string;
  label: string;
  amount: number;
  description: string;
  ledgerCode: LedgerCodeModel;
  ledgerCodeId: string;
  outOfStateAmount: IOutOfStateFeeDefinitionModel;
  //** if a fee is used as a payment requirement this model is filled in on the get FeeDefinition(id) */
  credentialFeeDefinitions: ICredentialFeeDefinitionWithIdModel[];
  isFeeAlreadyAdded: boolean;

  constructor(data?: Partial<FeeDefinitionModel>) {
    if (!data) return;
    this.id = data.id;
    this.label = data.label;
    this.amount = data.amount;
    this.description = data.description;
    this.ledgerCode = data.ledgerCode;
    this.ledgerCodeId = data.ledgerCodeId;
    this.outOfStateAmount = data.outOfStateAmount;
    this.isFeeAlreadyAdded = data.isFeeAlreadyAdded;
  }
}

export class FeeDefinitionPagedResult {
  results: FeeDefinitionModel[];
  rowCount: number;
}

export const DEFAULT_PAGE_SIZE = 30;
